import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useAppContext } from 'contexts/app-context/hooks'

import { TServiceCardContent } from '../types/ServiceCard.types'

export const useServiceCard = ({
  confirmButton,
  details,
  title,
  to = Routes.ERROR,
}: TServiceCardContent) => {
  const { userSelectedEntity } = useAppContext()
  const navigate = useNavigate()

  const navigateTo = async () => {
    const action =
      to === Routes.MY_SERVICE_REQUESTS ? `selectSupportRequests` : 'selectFrequentQuestions'

    try {
      await sendSelectContent({
        flow: 'home',
        step: 'home',
        screen_name: Routes.HOME,
        element_name: action,
        element_type: 'button',
        parent_name: 'Home',
        scenario: JSON.stringify({
          screen: Routes.HOME,
          product: userSelectedEntity,
          to,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send service card tic', error)
    }

    navigate(to)
  }

  return {
    content: { confirmButton, details, title },
    onClick: navigateTo,
  }
}
